type UnavailabilityReason = {
  name: string;
  keyRank: number;
};

const unavailabilityReason: UnavailabilityReason = {
  name: "",
  keyRank: 0,
};

export type { UnavailabilityReason };

export { unavailabilityReason };
